<template lang="pug">
v-expansion-panel.elevation-0
  v-expansion-panel-content
    v-layout(align-center, slot='header')
      span Aanvraag formulier

    v-card.pa-4
      v-layout(align-center)
        text-field.monospace.mr-0(
          :label='"Link naar je eigen " + (isBusinessLease ? "Financial Lease" : "Krediet") + " formulier"'
          v-model='leaseFormUrl',
          read-only,
          disabled,
          ref='leaseFormUrlInput'
          )
        v-tooltip(top)
          v-btn.mb-3(icon, @click='copyToClipboard(leaseFormUrl)', slot='activator')
            v-icon(color='primary') fa fa-copy
          span Kopiëren

      p Je kan velden (als query string) toevoegen aan de URL om informatie mee te geven.

      v-card.pa-3.mb-3.monospace Voorbeeld: {{ leaseFormUrlExample }}

      p Alle velden behalve #[code domain] zijn optioneel maar meestal zal je het #[code leasebedrag] veld willen koppelen aan het product op je eigen website.
      p Velden in de URL nemen voorrang op de standaard waarden van het websiteprofiel. De velden #[code aanbetaling] en #[code slottermijn] worden niet gebruikt als het product soort #[b Overige] is.

      p Naast de standaard velden (zie tabel hieronderaan de pagina) zijn voor het aanvraag formulier ook de volgende velden beschikbaar:

      table.v-datatable.v-table.theme--light
        thead
          tr
            td: b Veld
            td: b Beschrijving
            td: b Verplicht
        tbody
          tr
            td: code herkomst
            td Link waar de klant vandaan komt
            td Nee
          tr
            td: code titel
            td Titel van het product
            td Nee
          tr
            td: code afbeelding
            td Afbeelding van het product
            td Nee
          tr
            td: code kenteken
            td Kenteken van de occasion
            td Nee
</template>

<script>
import { nperItems } from 'dealerfinanceservices-shared/src/helpers/constants'
import UrlParse from 'url-parse'

export default {
  props: {
    domain: String,
    isBusinessLease: Boolean
  },

  data () {
    return {
      expanded: false,
      nperItems,

      leaseFormUrl: `${process.env.VUE_APP_FORM_DOMAIN}/lease/${(this.isBusinessLease ? 'zakelijk' : 'particulier')}`,
      leaseFormUrlExample: null,
      leasePv: null,
      leaseDeposit: null,
      leaseFv: null,
      leaseNper: null
    }
  },

  methods: {
    init () {
      const parsed = UrlParse(this.leaseFormUrl)

      parsed.set('query', {
        domain: this.domain
      })

      this.leaseFormUrl = parsed.toString()

      // Build example URL with all parameters
      parsed.set('query', {
        leasebedrag: 20000,
        looptijd: 120,
        slottermijn: 5000
      })

      this.leaseFormUrlExample = parsed.toString()
    },

    copyToClipboard (str) {
      const el = document.createElement('textarea')
      el.value = str
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)

      this.$root.$snackbar.show('Gekopiëerd naar klembord')
    },

    generateleaseFormUrl () {
      setTimeout(() => {
        const parsed = UrlParse(this.leaseFormUrl)

        const query = {
          domain: this.domain
        }

        if (this.leasePv) query.leasebedrag = this.leasePv // Not allowed to be 0
        if (this.leaseDeposit !== null) query.aanbetaling = this.leaseDeposit
        if (this.leaseFv !== null) query.slottermijn = this.leaseFv
        if (this.leaseNper !== null) query.looptijd = this.leaseNper

        parsed.set('query', query)

        this.leaseFormUrl = parsed.toString()
      }, 10) // Because keyup is fired too early and eurofield isnt done calculating yet
    }
  },

  async created () {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/responsive.scss";

table {
  td {
    @include phone {
      padding: 5px !important;
      font-size: 10px;
    }
  }
}
</style>
